import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../../config';
import { FaLightbulb } from 'react-icons/fa';
import { FaTrash } from 'react-icons/fa';

function Notifications() {
  const [notifications, setNotifications] = useState([]);
  const [formData, setFormData] = useState({ title: '', message: '' });

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = () => {
    axios.get(`${config.apiBaseUrl}/notifications/notify.php`)
      .then(res => setNotifications(res.data))
      .catch(err => console.error(err));
  };

  const handleSubmit = () => {
    axios.post(`${config.apiBaseUrl}/notifications/notify.php`, formData)
      .then(() => {
        Swal.fire('Success', 'Notification Added', 'success');
        setFormData({ title: '', message: '' });
        fetchNotifications();
      });
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(`${config.apiBaseUrl}/notifications/notify.php?id=${id}`)
          .then(() => {
            Swal.fire('Deleted!', 'Notification has been deleted.', 'success');
            fetchNotifications();
          })
          .catch(() => {
            Swal.fire('Error', 'Failed to delete notification.', 'error');
          });
      }
    });
  };

  const toggleVisibility = (id, currentVisibility) => {
  const newVisibility = !currentVisibility;

    axios.post(`${config.apiBaseUrl}/notifications/notify.php`, {
      id,
      visible_to_website: newVisibility,
      action: 'toggle_visibility'
    })
    .then(() => {
      fetchNotifications();
    })
    .catch(() => {
      Swal.fire('Error', 'Failed to toggle visibility', 'error');
    });
  };

  return (
    <div>
      <h3>Add Notification</h3>
      <input 
        value={formData.title}
        onChange={e => setFormData({ ...formData, title: e.target.value })}
        placeholder="Title"
        className="form-control mb-2"
      />
      <textarea
        value={formData.message}
        onChange={e => setFormData({ ...formData, message: e.target.value })}
        placeholder="Message"
        className="form-control mb-2"
      />
      <button onClick={handleSubmit} className="btn btn-primary">Post</button>

      <h4 className="mt-4">Previous Notifications</h4>
      {/*  */}
      <ul className="list-group">
  {notifications.map(n => (
    <li key={n.id} className="list-group-item d-flex justify-content-between align-items-center">
      <div>
        <strong>{n.title}</strong><br />
        {n.message}<br />
        <small className="text-muted">
          {n.date_created ? new Date(n.date_created).toLocaleString() : 'No date'}
        </small>
      </div>

      <div className="d-flex align-items-center gap-2">
        <button
          onClick={() => handleDelete(n.id)}
          className="btn btn-sm btn-danger"
          title="Delete"
        >
          <FaTrash />
        </button>

        <button
          onClick={() => toggleVisibility(n.id, n.visible_to_website)}
          className="btn btn-sm"
          style={{
            backgroundColor: n.visible_to_website ? '#28a745' : '#6c757d',
            color: 'white'
          }}
          title={n.visible_to_website ? 'Visible on website' : 'Hidden from website'}
        >
          <FaLightbulb color={n.visible_to_website ? 'yellow' : 'white'} />
        </button>
      </div>
    </li>
  ))}
</ul>

    </div>
  );
}

export default Notifications;
